import React from 'react'
import { Row, Col, Card, Typography, Avatar, Divider } from 'antd';
import { RightCircleFilled } from '@ant-design/icons';
import EduSolData from './EduSolData'
import './edusolutions.css'
import 'antd/dist/antd.css';
import 'font-awesome/css/font-awesome.min.css';


const { Title, Text } = Typography;

function EduSolutions() {
    return (
        <div className="edusol-container" id="edusolutions">
            <div className="edusol-heading-container">
                <Text className="paragraph">
                    <p>
                        Best Learning Experiences
                    </p>
                </Text>
                <Title className="sectionHeading-edusol">We Provide Educational Solutions</Title>
            </div>
            <Row justify="center" className="edu-sol-cn" gutter={{xs: 8, sm: 16, md: 24, lg: 32, xl: 16 }} >
                {EduSolData.map(edusol =>
                    <Col className="" xs={22} sm={11} md={11} lg={7} xl={8}>

                        <Card className="edu-sol-card">
                            <Divider className="edusolDivider">
                                <Avatar shape="square" size={64} src={edusol.img} />
                            </Divider>
                            <Title className="course-title">
                                {edusol.title}
                            </Title>
                            <Text className="course-description">
                                <p>
                                    {edusol.description}
                                </p>
                            </Text>
                            <Text className="edusol-read-more">
                                <a href="https://www.facebook.com/"> Read More <RightCircleFilled className="read-mr-icon" /></a>
                            </Text>
                        </Card>
                    </Col>
                )}
            </Row>
        </div>
    )
}

export default EduSolutions;